import {SubscriptionServicePromiseClient} from 'grpc-bob/subscription_grpc_web_pb';
import {StudentPromiseClient} from 'grpc-bob/student_grpc_web_pb';
import {SchoolServicePromiseClient} from 'grpc-bob/schools_grpc_web_pb';
import {MasterDataServicePromiseClient} from 'grpc-bob/master_data_grpc_web_pb';
import {API_ENDPOINT, METADATA} from '../configs';

//todo: create wrapper to provide user token when call Client method BUT RESERVING TYPE_SAFE
export const SubscriptionClient = new SubscriptionServicePromiseClient(API_ENDPOINT);
export const StudentClient = new StudentPromiseClient(API_ENDPOINT);
export const SchoolClient = new SchoolServicePromiseClient(API_ENDPOINT);
export const MasterClient = new MasterDataServicePromiseClient(API_ENDPOINT);


//object metadata 
export function getMetadata(token: string) {
    return {
        [METADATA.KEY_TOKEN]: token,
        [METADATA.KEY_PKG] : METADATA.VALUE_PKG,
        [METADATA.KEY_VERSION]: METADATA.VALUE_VERSION
    }
}